/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    language?: string;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    id: number;
    /**
     * 
     * @type {Role}
     * @memberof UserResponse
     */
    role: Role;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    organizationId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserResponse
     */
    localityIds: Array<number>;
}

export function UserResponseFromJSON(json: any): UserResponse {
    return UserResponseFromJSONTyped(json, false);
}

export function UserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phoneNumber': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'id': json['id'],
        'role': RoleFromJSON(json['role']),
        'organizationId': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'localityIds': json['locality_ids'],
    };
}

export function UserResponseToJSON(value?: UserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'phone_number': value.phoneNumber,
        'language': value.language,
        'id': value.id,
        'role': RoleToJSON(value.role),
        'organization_id': value.organizationId,
        'locality_ids': value.localityIds,
    };
}

